import * as R from 'ramda'

export const getImsxDescription = (response: any) =>
  R.pathOr<string>('', ['data', 'errors', 0, 'imsxDescription'], response)
